<template lang="jade">
  div.Button-bar
    component(v-for="field in content" ":is"="field.type" ":fdata.sync"="field")
</template>

<script>
import _ from 'lodash'

export default {
  data () {
    return {
      uid: this.$parent.uid
    }
  },
  props: {
    content: {
      type: Array,
      coerce: x => _.get(x, 'fields[0].content'),
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// profile.vue?5618217a